export const getClusterIdFromLink = (): string | undefined => {
  const { pathname } = window.location;
  const parts = pathname.split('/');
  // support OP platform routing
  const externalClustersIndex = parts.indexOf('external-clusters');
  if (externalClustersIndex > 0) {
    return parts[externalClustersIndex + 1];
  }
  return undefined;
};
